import React from 'react';

const CornerCurve = props => (
  <svg width="1em" height="1em" viewBox="0 0 318 243" fill="none" {...props}>
    <path d="M0 243C184.4 221 289.167 72.167 318.5.5V243H0z" fill="#CD3937" />
  </svg>
);

export default CornerCurve;
